import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_FINAL_CTA } from '@src/constants/LeadGenerationConstants/index';
import useRequestCallback from './useRequestCallback';

const Band = () => {
  const onSubmitPageOne = useRequestCallback();
  return (
    <section>
      <div className={styles.wrap}>
        <div className={styles.band}>
          <div style={{ maxWidth: 640 }}>
            <h2>Not sure you&apos;re a fit?</h2>
            <p>
              Request a callback — a program advisor will tell you honestly whether to start now
              or prep first. No payment, no commitment.
            </p>
          </div>
          <LeadGenerationButton
            text="Request a Callback"
            isOnePageForm
            formHeading="Request Callback"
            pageOneButtonText="Call me back"
            onSubmitPageOne={onSubmitPageOne}
            buttonLocation={LEAD_GEN_FINAL_CTA}
            wrapperClassName="shrink-0"
            className="h-auto w-auto shrink-0 rounded-xl px-[22px] py-3 text-[15px] shadow-none hover:shadow-none"
          />
        </div>
      </div>
    </section>
  );
};

export default Band;
